import React, { Component } from "react";
import "styled-components/macro";

import imgImagePlaceholder from "./images/image-placeholder.svg";
import sizes from "./utils/sizes";
import guessMyDevice from "./utils/guess-my-device";
import isSafari from "./utils/is-safari";

export default class MockBrowser extends Component {
  initialState = {
    isMockSidebarVisible: false,
    isMockReadingViewVisible: false,
    isArticleExpanded: false,
    sidebarScrollTop: 0,
    readingViewScrollLeft: 0,
  };
  state = this.initialState;
  scrollIncrement = 132;
  device = guessMyDevice();
  // size = 100;
  // animationMs = 350;
  // animationGlowMs = this.animationMs;
  // animationGlowDelayMs = this.animationMs * 0.25;
  render() {
    const { scale } = this.props;
    return (
      <div
        css={`
          position: relative;
          left: ${this.device === 'tablet' ? 90 : 20}px;
          top: ${this.device === "mobile" ? 170 : this.device === 'desktop' ? 160 : this.device === 'tablet' ? 180 : 0}px;
          perspective: 500px;
          transform: scale(${scale || 1});
        `}
      >
        <div
          css={`
            perspective: 1000px;
          `}
        >
          <div
            css={`
              z-index: 0;
              position: absolute;
              top: -118px;
              right: -52px;
              padding: 8px;
              width: 609px;
              height: 467px;
              background: hsl(0 0% 97.3% / 1);
              border-radius: 5px;
              overflow: hidden;
              transform: skew(-19deg, 0deg) rotateX(15.9deg) rotateY(-21deg)
                scale(0.85);
              border-bottom-right-radius: 0;
              box-shadow: ${this.device === "mobile" ? "10px 10px 0px 10px #e1e1e9" : "none"};
            `}
          >
            <div
              css={`
                display: flex;
                height: 22px;
              `}
            >
              {Array(3)
                .fill(null)
                .map((x, index) => (
                  <span
                    key={index}
                    css={`
                      margin-left: 3px;
                      width: 13px;
                      height: 13px;
                      border-radius: 10px;
                      background-color: #e1e1e9;
                    `}
                  />
                ))}
            </div>
            <div>
              <div
                css={`
                  display: flex;
                `}
              >
                {/* sidebar */}
                <div
                  css={`
                    min-width: 170px;
                    height: 445px;
                    overflow: hidden;
                  `}
                >
                  <div
                    css={`
                      width: 100%;
                      height: 1000px;
                      transform: translateY(-${this.state.sidebarScrollTop}px)
                        translateX(
                          ${this.state.isMockSidebarVisible ? 0 : -170}px
                        );
                      transition: transform 350ms ease-out 350ms;
                      background: #f7f7fb;
                    `}
                  >
                    {/* mock feeds+foldedrs <<8th one!>>>*/}
                    {Array(50)
                      .fill(null)
                      .map((x, index) => (
                        <div
                          key={index}
                          css={`
                            display: flex;
                            width: 100%;
                            height: 45px;
                          `}
                        >
                          {/* thumbnail */}
                          <div
                            css={`
                              margin: 5px 7px 5px 14px;
                              width: 35px;
                              height: 35px;
                              background-color: #e1e1e9;
                            `}
                          />
                          {/* title + description */}
                          <div
                            css={`
                              display: flex;
                              justify-content: center;
                              flex-direction: column;
                            `}
                          >
                            <div
                              css={`
                                margin-bottom: 2px;
                                width: 97px;
                                height: 10px;
                                background-color: #e1e1e9;
                              `}
                            />
                            <div
                              css={`
                                width: 77px;
                                height: 9px;
                                background-color: #e1e1e9;
                              `}
                            />
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
                {/* article cards */}
                <div
                  css={`
                    margin: 10px;
                    width: 419px;
                    height: 425px;
                    overflow: hidden;
                  `}
                >
                  <div
                    css={`
                      z-index: 0;
                      position: relative;
                      display: flex;
                      width: 100%;
                      height: 100%;
                      opacity: ${this.state.isMockReadingViewVisible ? 1 : 0};
                      transform: perspective(100px)
                        translateZ(
                          ${this.calcReadingViewZPos(
                      this.state.isMockReadingViewVisible,
                      this.state.isArticleExpanded
                    )}px
                        )
                        translateX(-${this.state.readingViewScrollLeft}px);
                      transition: opacity 350ms ease-out 350ms,
                        transform 350ms ease-out 350ms;
                    `}
                  >
                    {Array(6)
                      .fill(null)
                      .map((x, index) => (
                        <div
                          key={index}
                          css={`
                            margin-right: 10px;
                            min-width: 254px;
                            background: #efeff4;
                          `}
                        />
                      ))}
                  </div>
                </div>
                {/* expanded fulllll article */}
                <div
                  css={`
                    position: absolute;
                    top: 30px;
                    left: 178px;
                    padding: 15px;
                    width: 409px;
                    height: 415px;
                    overflow: hidden;
                    opacity: ${this.state.isArticleExpanded ? 1 : 0};
                    transform: perspective(100pe1e1e9x)
                      translateZ(${this.state.isArticleExpanded ? 0 : -10}px);
                    transition: opacity 200ms ease-out 350ms,
                      transform 600ms ease-out 350ms;
                    background: #f7f7fb;
                  `}
                >
                  {/* headline */}
                  <div
                    css={`
                      margin-bottom: 6px;
                      width: 309px;
                      height: 36px;
                      background-color: #;
                    `}
                  />
                  {/* subline */}
                  <div
                    css={`
                      margin-bottom: 14px;
                      width: 209px;
                      height: 15px;
                      background-color: #efeff4;
                    `}
                  />
                  {/* block */}
                  <div
                    css={`
                      margin: 0 0 5px;
                      height: 99px;
                      background-color: #efeff4;
                    `}
                  />
                  {/* block with image */}
                  <div
                    css={`
                      display: flex;
                      margin: 0 0 2px;
                    `}
                  >
                    {/* image */}
                    <div
                      css={`
                        position: relative;
                        margin-right: 2px;
                        width: 139px;
                        height: 139px;
                        background-color: #efeff4;
                      `}
                    >
                      <img
                        src={imgImagePlaceholder}
                        css={`
                          position: relative;
                          top: 14px;
                        `}
                        alt="mockimage"
                      />
                    </div>
                    {/* block (floating) */}
                    <div
                      css={`
                        width: 268px;
                        height: 139px;
                        background-color: #efeff4;
                      `}
                    />
                  </div>
                  {/* block */}
                  <div
                    css={`
                      margin: 0 0 4px;
                      height: 69px;
                      background-color: #efeff4;
                    `}
                  />
                  {/* block */}
                  <div
                    css={`
                      margin: 0 0 2px;
                      height: 200px;
                      background-color: #efeff4;
                    `}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right face */}
        <div
          css={`
            position: relative;
            right: 1px;
            display: ${this.device !== "desktop" ? "none" : "block"};
            z-index: 2;
            width: 18px;
            height: 447px;
            background-color: #e1e1e9;
            border-radius: 4px;
            transform: translate(${sizes[this.device].landscape * 1.04098360656}px, -76px) skew(0deg, 40deg) rotateY(8deg)
              rotateX(-5.75deg);
            transform-origin: right;
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 3px;
          `}
        />
        {/* Bottom face */}
        <div
          css={`
            z-index: 2;
            display: ${this.device !== "desktop" ? "none" : "block"};
            width: 596px;
            height: 15px;
            background-color: #e1e1e9;
            border-radius: 4px;
            transform: translate(654px, -108px) skew(43deg, 0deg) rotateY(0deg)
              rotateZ(1.45deg) rotateX(0deg);
            transform-origin: bottom;
            border-top-left-radius: 2px;
          `}
        />
      </div>
    );
  }
  componentDidUpdate(prevProps, prevState) {
    const { keyAction, animationCycles } = this.props;
    const keyActionChanged = prevProps.keyAction !== keyAction;
    const animationCyclesChanged = prevProps.animationCycles !== animationCycles

    if (animationCyclesChanged)
    {
      this.setState(this.initialState)
    }

    if (keyActionChanged && keyAction === "interface_appear")
    {
      this.setState({ isMockSidebarVisible: true });
      return;
    }

    if (keyActionChanged && keyAction === "scroll_forwards")
    {
      // scroll sidebar down
      if (
        this.state.isMockSidebarVisible &&
        !this.state.isMockReadingViewVisible
      )
      {
        this.setState({
          sidebarScrollTop: this.state.sidebarScrollTop + this.scrollIncrement,
        });
      }
      // scroll article cards right
      if (
        this.state.isMockSidebarVisible &&
        this.state.isMockReadingViewVisible
      )
      {
        this.setState({
          readingViewScrollLeft: this.readingViewScrollLeftCalc(
            this.state.readingViewScrollLeft
          ),
        });
      }
    }

    if (keyActionChanged && this.props.keyAction === "scroll_backwards")
    {
      this.setState({
        sidebarScrollTop: this.state.sidebarScrollTop - this.scrollIncrement,
      });
    }

    if (keyActionChanged && this.props.keyAction === "choose")
    {
      // reveal readingview
      if (
        this.state.isMockSidebarVisible &&
        !this.state.isMockReadingViewVisible
      )
      {
        this.setState({ isMockReadingViewVisible: true });
      }

      // expand article
      if (
        this.state.isMockSidebarVisible &&
        this.state.isMockReadingViewVisible
      )
      {
        this.setState({ isArticleExpanded: true });
      }
    }
    if (keyActionChanged && this.props.keyAction === "backout")
    {
      // expandart
      if (this.state.isArticleExpanded)
      {
        return this.setState({ isArticleExpanded: false });
      }
      if (this.state.isMockReadingViewVisible)
      {
        return this.setState({ isMockReadingViewVisible: false });
      }
      if (this.state.isMockSidebarVisible)
      {
        return this.setState({ isMockSidebarVisible: false });
      }
    }
  }

  readingViewScrollLeftCalc = (readingViewScrollLeft) => {
    if (readingViewScrollLeft === 0)
    {
      return 180;
    } else return 455;
  };

  calcReadingViewZPos = (isMockReadingViewVisible, isArticleExpanded) => {
    return (isMockReadingViewVisible && isArticleExpanded) ||
      !isMockReadingViewVisible
      ? -3
      : 0;
  };
}
